<script setup>
import { useAudienceConsole } from '@/components/audience/audienceConsole'

import AudienceEmailCapture from '@/components/audience/AudienceEmailCapture.vue'

// Configuration only: the capture mode, the form's copy, the privacy link and
// the delivery webhook. What the form collects lives on the Contacts sub-tab —
// setup and data got distinct tabs (and deliberately distinct names) so
// neither buries the other.

const props = defineProps({
	stream: {
		type: Object,
		required: true,
		validator(v) {
			return Object.prototype.hasOwnProperty.call(v, '_id')
		}
	},
	streamAlive: {
		type: Boolean
	}
})

const {
	settings,
	isSaving,
	usingCastr,
	onEmailCaptureSave
} = useAudienceConsole()
</script>

<template>
	<section v-if="!usingCastr" class="bg-surface-1 rounded-xl p-4 md:p-5">
		<p class="text-sm text-surface-text-1 mb-1">Email capture is not available.</p>
		<p class="text-tiny text-surface-7 mb-0">
			Chat is switched off. Turn it on with the switch above to ask viewers for their
			email in the player.
		</p>
	</section>

	<section v-else class="bg-surface-1 rounded-xl p-4 md:p-5">
		<div class="mb-3">
			<h4 class="text-base mb-1">Email capture</h4>
			<p class="text-sm text-surface-8 mb-0">
				Ask viewers for their email in the player, and have each capture sent to a webhook
				as it arrives. What the form collects is on the
				<router-link :to="{ name: 'LivestreamManageAudienceContacts' }">Contacts</router-link>
				tab.
			</p>
		</div>
		<AudienceEmailCapture :stream-id="stream._id" :email-capture="settings.emailCapture"
			:saving="isSaving('emailCapture')" @save="onEmailCaptureSave" />
	</section>
</template>
